"use client";

import { useRouter } from "next/navigation";
import { DataTable, EmptyState } from "@/components/shared";
import type { PublisherGameWishlist } from "../types";
import { publisherGameWishlistColumns } from "../config";
import { PublisherGameWishlistCards } from "./PublisherGameWishlistCards";

interface PublisherGameWishlistListProps {
  games: PublisherGameWishlist[];
}

export function PublisherGameWishlistList({
  games,
}: PublisherGameWishlistListProps) {
  const router = useRouter();

  if (games.length === 0) {
    return <EmptyState message="No wishlist games found for this publisher." />;
  }

  return (
    <div className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden">
      <DataTable
        data={games}
        columns={publisherGameWishlistColumns}
        getRowHref={(game) => `/app/${game.appid}`}
        getRowAriaLabel={(game) => game.name}
        getRowKey={(game) => game.appid}
      />
      <PublisherGameWishlistCards
        games={games}
        onCardClick={(appid) => router.push(`/app/${appid}`)}
      />
    </div>
  );
}

